document.addEventListener('DOMContentLoaded', function () {
  var chips = document.querySelectorAll('[data-mm2-filter]');
  var tiles = document.querySelectorAll('[data-mm2-tile]');
  var emptyMsg = document.querySelector('[data-mm2-empty]');
  chips.forEach(function (chip) {
    chip.addEventListener('click', function () {
      chips.forEach(function (c) { c.classList.remove('is-active'); });
      chip.classList.add('is-active');
      var f = chip.getAttribute('data-mm2-filter');
      var visible = 0;
      tiles.forEach(function (t) {
        var cats = (t.getAttribute('data-mm2-cat') || '').split(' ');
        var show = f === 'all' || cats.indexOf(f) !== -1;
        t.style.display = show ? '' : 'none';
        if (show) visible++;
      });
      if (emptyMsg) emptyMsg.style.display = visible === 0 ? 'block' : 'none';
    });
  });
  var led = document.querySelector('[data-mm2-led]');
  if (led) {
    var raw = led.getAttribute('data-mm2-led-values') || '';
    var values = raw.split(',').map(function (v) { return v.trim(); }).filter(Boolean);
    if (values.length > 1) {
      var i = 0;
      setInterval(function () {
        i = (i + 1) % values.length;
        led.textContent = values[i];
      }, 2000);
    }
  }
  var sticky = document.querySelector('[data-mm2-sticky]');
  var hero = document.querySelector('[data-mm2-hero-anchor]');
  if (sticky && hero) {
    window.addEventListener('scroll', function () {
      var trigger = hero.offsetTop + hero.offsetHeight;
      if (window.scrollY > trigger) { sticky.classList.add('is-visible'); } else { sticky.classList.remove('is-visible'); }
    });
  }

  /* Quick add-to-cart from the buy button. The tile itself is now a real
     link to the product page (see plan-tile.liquid), so we stop the click
     from bubbling up and navigating away, and preventDefault since the
     button lives inside an <a>. After a successful add we send the visitor
     straight to the cart page — no hidden badge to notice, no confusion
     about what to do next. */
  function addToCart(variantId, btn) {
    if (!variantId) return;
    var original = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Agregando…';
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: variantId, quantity: 1 }) })
      .then(function (res) { if (!res.ok) throw new Error('No se pudo comprar'); return res.json(); })
      .then(function () {
        btn.textContent = '¡Agregado! Yendo al carrito…';
        window.location.href = '/cart';
      })
      .catch(function () {
        btn.textContent = 'Error, reintenta';
        setTimeout(function () { btn.textContent = original; btn.disabled = false; }, 1800);
      });
  }

  document.querySelectorAll('[data-mm2-buy]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      addToCart(btn.getAttribute('data-variant-id'), btn);
    });
  });
});
